// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../directives/disabled/disabled.directive";
import * as i3 from "../../../directives/icon/icon.directive";
const _c0 = a0 => ({ "custom-controls-stacked": a0 });
function CheckboxGroupComponent_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", option_r2.icon);
} }
function CheckboxGroupComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 2)(1, "input", 3);
    i0.ɵɵlistener("change", function CheckboxGroupComponent_label_1_Template_input_change_1_listener() { const option_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setOption(option_r2)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, CheckboxGroupComponent_label_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelement(3, "span", 5)(4, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", option_r2.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", option_r2.value)("checked", ctx_r2.state[option_r2.value]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r2.icon !== undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", option_r2.additionalClasses !== undefined ? option_r2.additionalClasses : "")("textContent", option_r2.label);
} }
/**
 *
 * Checkbox Group Component
 *
 * Input Properties:
 *
 *  groupName: The name that should be used for all buttons in this checkbox group. NOTE: If there are multiple
 *             radio groups on the same page, they must all use different groupNames.
 *  options: An array of CheckboxOptions, used to display the labels and whether they are checked.
 *
 *
 * Output Properties:
 *
 *  checkedHandler: EventEmitter that emits the checkbox results whenever an option is checked
 *
 */
export class CheckboxGroupComponent {
    constructor() {
        this.displayVertical = true;
        this.checkedHandler = new EventEmitter();
        this.state = {};
    }
    ngOnChanges(changes) {
        /**
         * We have to update onChanges instead of just onInit because it's possible that the checkbox may be updated
         * without clicking an option. For example, changing the URL of a checkbox that is connected to AppState (e.g.
         * the owner filter on the customs security list page) should update the checked status).
         */
        const newState = {};
        if (changes.options) {
            changes.options.currentValue.forEach((option) => {
                newState[option.value] = option.checked;
            });
        }
        this.state = newState;
        this.checkedHandler.emit(newState);
    }
    setOption(option) {
        const newState = { ...this.state };
        newState[option.value] = !newState[option.value];
        this.state = newState;
        this.checkedHandler.emit(newState);
    }
    trackByValue(_index, option) {
        return option.value;
    }
}
CheckboxGroupComponent.ɵfac = function CheckboxGroupComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CheckboxGroupComponent)(); };
CheckboxGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxGroupComponent, selectors: [["ycn-checkbox-group"]], inputs: { options: "options", groupName: "groupName", displayVertical: "displayVertical" }, outputs: { checkedHandler: "checkedHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 5, consts: [[3, "ngClass"], ["class", "custom-control custom-checkbox", "ycnDisabled", "", 3, "disabled", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["autocomplete", "off", "type", "checkbox", 1, "custom-control-input", 3, "change", "id", "checked"], [4, "ngIf"], [1, "custom-control-indicator"], [1, "custom-control-description", 3, "ngClass", "textContent"], ["ycnIcon", "", 1, "fill-current", "text-gray-30", "-mb-4", "mr-1", 3, "name"]], template: function CheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CheckboxGroupComponent_label_1_Template, 5, 6, "label", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx.displayVertical));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.options)("ngForTrackBy", ctx.trackByValue);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.DisabledDirective, i3.IconDirective], encapsulation: 2 });
